module.exports = __webpack_public_path__ + "img/checkout_complete.12584343.svg";